import React from 'react';
import { motion } from 'framer-motion';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import { testimonials } from '../data/hotelData';
import Newsletter from '../components/Newsletter/Newsletter';
import './TestimonialsPage.css';

const allTestimonials = [
  ...testimonials,
  { id: 5, name: "Priya Sharma", location: "Mumbai, India", rating: 5, comment: "The spa at Grand Luxe is unlike anything I've experienced. The Ayurvedic treatments were exceptional, and the therapists were knowledgeable and professional.", avatar: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=150&q=80", date: "November 2023" },
  { id: 6, name: "David Okonkwo", location: "Lagos, Nigeria", rating: 5, comment: "Came for a conference, stayed for the experience. The business center was top-notch and the evening in the sky bar with those views was simply breathtaking.", avatar: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=150&q=80", date: "October 2023" },
];

export default function TestimonialsPage() {
  return (
    <main>
      <div className="page-banner">
        <div className="page-banner-content">
          <span className="section-badge">Guest Reviews</span>
          <h1>Testimonials</h1>
          <p>Hear from those who've experienced Grand Luxe</p>
        </div>
      </div>

      <section className="section testimonials-page">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Real Experiences</span>
            <h2 className="section-title">What Our Guests Say</h2>
            <div className="gold-line" />
            <div className="rating-summary">
              <div className="overall-rating">
                <strong>4.9</strong>
                <div className="rating-stars">
                  {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                </div>
                <span>Based on 1,200+ reviews</span>
              </div>
            </div>
          </div>

          <div className="testimonials-page-grid">
            {allTestimonials.map((t, i) => (
              <motion.div
                key={t.id}
                className="testimonial-page-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <FaQuoteLeft className="t-quote-icon" />
                <div className="t-stars">
                  {[...Array(t.rating)].map((_, i) => <FaStar key={i} />)}
                </div>
                <p className="t-comment">"{t.comment}"</p>
                <div className="t-author">
                  <img src={t.avatar} alt={t.name} />
                  <div>
                    <strong>{t.name}</strong>
                    <span>{t.location} · {t.date}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Newsletter />
    </main>
  );
}
